<template>
	<div class="link-auto-table-filter-form-wrapper" v-if="!!dynamicFilterList">
		<link-form-grid>
			<link-form-item v-for="(item,index) in list" :key="index" :label="!!item?item.title:''">
				<link-dynamic-filter :value="item" ref="filters" :width="'100%'" v-if="!!item"/>
			</link-form-item>
			<link-form-item class="link-auto-table-filter-form-buttons">
				<link-button :label="$t('LinkForm.reset')" type="line" @click="reset"/>
				<link-button :label="$t('LinkForm.query')" @click="confirm"/>
				<link-button type="none" @click="p_show = !p_show" v-if="needCollapse">
					<span>展开</span>
					<link-icon :icon="p_show?'link-icon-up':'link-icon-down'"/>
				</link-button>
			</link-form-item>
		</link-form-grid>
	</div>
</template>

<script>
    export default {
        name: "link-auto-table-filter-form",
        props: {
            linkFilterOptions: {type: Array},
            show: {type: Boolean, default: true},
        },
        data() {
            return {
                dynamicFilterList: null,
                p_show: null,
            }
        },
        watch: {
            show: {
                immediate: true,
                handler(val) {
                    this.p_show = val
                },
            },
            linkFilterOptions: {
                immediate: true,
                handler() {
                    const validOption = (!this.linkFilterOptions || this.linkFilterOptions.length === 0) ? null : this.linkFilterOptions.filter(fo => !!fo.column && !!fo.column.formFilter)
                    if (!validOption || validOption.length === 0) return null
                    this.dynamicFilterList = validOption.map(linkFilterOption => new DynamicFilter(linkFilterOption))
                },
            },
        },
        computed: {
            needCollapse() {
                return !!this.dynamicFilterList && this.dynamicFilterList.length > 3
            },
            list() {
                let ret = [...(this.dynamicFilterList || [])]
                if (!!this.needCollapse && !this.p_show) {
                    ret = ret.slice(0, 2)
                }
                let left = ret.length % 3
                switch (left) {
                    case 1:
                        ret.push(null)
                        break;
                    case 0:
                        ret.push(null, null)
                }

                return ret
            },
        },
        methods: {
            async reset() {
                if (!!this.dynamicFilterList && this.dynamicFilterList.length > 0) {
                    this.dynamicFilterList.forEach(df => df.clearValue())
                }
                await this.$lv.nextTick()
                this.confirm()
            },
            async confirm() {
                await this.$lv.nextTick()
                this.$refs.filters.forEach(item => item.getValue())
                this.$emit('confirm', this.dynamicFilterList)
            },
            lv_clickTitle() {
                this.p_show = !this.p_show
                this.$emit('update:show', this.p_show)
            },
        }
    }
</script>

<style lang="scss">
	.link-auto-table-filter-form-wrapper {
		.link-auto-table-title-show {
			.link-auto-table-title-icon {
				transform: rotate(180deg);
			}
		}

		.link-auto-table-filter-form-buttons {
			.link-form-item-content {
				width: 100% !important;
				justify-content: flex-end;
			}

			.link-button {
				&:not(:first-child) {
					margin-left: 8px;
				}
			}
		}
	}
</style>
